import React, { useEffect, useState } from "react";
import { Form, Input, Row, Col, Card, Table, Typography, Button, InputNumber, Popconfirm, Space, Select, Modal, DatePicker, Divider, AutoComplete, Tooltip, Tabs, Timeline } from "antd";
import { DeleteOutlined, PlusOutlined, InfoCircleOutlined, CommentOutlined, EyeOutlined, ArrowLeftOutlined, UploadOutlined, FilePdfOutlined, FileImageOutlined, DeleteOutlined as DeleteIcon } from '@ant-design/icons';
import TextArea from "antd/es/input/TextArea";

import { QuotationService } from "../../../Services/Manage/QuotationService";
import { ServicetypeService } from "../../../Services/Manage/ServicetypeService";

import useMessage from "antd/es/message/useMessage";
import { LetterService } from "../../../Services/Manage/LetterService";
import { ENDPOINT } from "../../../Services/ENDPOINT";
import { UserService } from "../../../Services/Manage/UserService";
import { BankService } from "../../../Services/Manage/BankService";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";


import { InvoiceService } from "../../../Services/Manage/InvoiceService";
import { ExpenseServices } from "../../../Services/Manage/ExpenseServices";
import { Upload } from "antd";

import CreatePayment from "../../modals/CreatePayment";
import { EnquiryService } from "../../../Services/Manage/EnquiryService";
import html2pdf from 'html2pdf.js';
import QuotationInvoiceTemplate from "../template/QuotationInvoiceTemplate";
import QuotationInvoiceTemplateV2 from "../template/QuotationInvoiceTemplateV2";
import { Collapse } from "antd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

dayjs.extend(utc);
dayjs.extend(timezone);

const primaryColor = "rgba(11, 93, 148, 0.95)";

const scopeQuillModules = {
    toolbar: [
        [{ font: [] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ align: [] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ script: "sub" }, { script: "super" }],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        ["link"],
        ["clean"],
    ],
};

const AddInvoiceData = ({
    Eqslected,
    invoice_no,
    data,
    rowData,
    eqData,
    invoiceScope,
    invoiceId,
    customerForm,
    viewMode = false,
    invoiceDate = null,
    invoiceQuNo = null,
    extraDetails = null,
    onInvoiceGenerated = null,
    invoiceRecord = null,
customerInfo = {},
    onPaymentSummaryChange = null,
    onSendInvoice = null,

}) => {
    const { Text, Title } = Typography;
    const [form] = Form.useForm();
    const [footerForm] = Form.useForm();
    const [dataSource, setDataSource] = useState([]);
    const [count, setCount] = useState(3);
    const [grandTotal, setGrandTotal] = useState(0);
    const [message, msgContc] = useMessage();
    const [letterHead, setLetterHead] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedTCOption, setSelectedTCOption] = useState([]);
    const [dgSign, setDGsign] = useState(null);
    const [dgSignOption, setDGsignOption] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [generatingInvoice, setGeneratingInvoice] = useState(false);
    const [bankModalOpen, setBankModalOpen] = useState(false);
    const [signModalOpen, setSignModalOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);
    const [bankAc, setBankAc] = useState(null);
    const [bankAcOption, setBankAcOption] = useState([]);

    useEffect(() => {
        if (invoiceRecord && selectedTCOption.length > 0) {
            const tc = selectedTCOption.find(
                item => Number(item.value) === Number(invoiceRecord.tc_id)
            );

            if (tc) {
                setSelectedValue(tc);
            } else if (invoiceRecord.tc_content) {
                setSelectedValue({
                    value: null,
                    data: invoiceRecord.tc_content,
                });
            }
        }
    }, [invoiceRecord, selectedTCOption]);

    useEffect(() => {
        if (invoiceRecord && bankAcOption.length > 0) {
            const bank = bankAcOption.find(
                item => Number(item.value) === Number(invoiceRecord.bank_id)
            );

            if (bank) {
                setBankAc(bank);
                footerForm.setFieldsValue({
                    bank_ac: bank.value,
                });
            }
        }
    }, [invoiceRecord, bankAcOption]);

    useEffect(() => {
        if (invoiceRecord && dgSignOption.length > 0) {
            const sign = dgSignOption.find(
                item => Number(item.value) === Number(invoiceRecord.sign_id)
            );
            if (sign) setDGsign(sign);
        }
    }, [invoiceRecord, dgSignOption]);

    const navigate = useNavigate();
    const [printInvoice, setPrintInvoice] = useState(false);
    const [generatedKey, setGeneratedKey] = useState(null);

    const [templateModalOpen, setTemplateModalOpen] = useState(false);
    const [selectedPrintQuNo, setSelectedPrintQuNo] = useState(null);

    const [paymentModalOpen, setPaymentModalOpen] = useState(false);
    const [quotationNo, setQuotationNo] = useState(null);
    const [options, setOptions] = useState([]);
    const [scope, setScope] = useState("");
    const [descOptions, setDescOptions] = useState([]);
    const [descSearch, setDescSearch] = useState("");
    const taxOptions = ["GST", "VAT", "Service Tax", "Excise", "Custom Duty"];

    const [printCount, setPrintCount] = useState(data?.print_count || 0);

    // overall discount applied on the invoice (₹) — shown in the Sub Total block
    const [overallDiscount, setOverallDiscount] = useState(0);

    const [internalNote, setInternalNote] = useState("");
    const [editingNote, setEditingNote] = useState(false);
    const [savedNote, setSavedNote] = useState("");
    const [paymentHistory, setPaymentHistory] = useState([]);

    // Separate state for the "Notes" tab inside Payment History card —
    // independent from the "Notes" section in Important Information.
    const [tabInternalNote, setTabInternalNote] = useState("");
    const [tabEditingNote, setTabEditingNote] = useState(false);
    const [tabSavedNote, setTabSavedNote] = useState("");

    const isInvoiceCreated = Boolean(invoiceId || generatedKey);

    const [showAllTimeline, setShowAllTimeline] = useState(false);
    const [showAllTabTimeline, setShowAllTabTimeline] = useState(false);
    const TIMELINE_LIMIT = 5;

    const fetchPaymentHistory = async () => {
        try {
            const key = invoice_no || invoiceQuNo || generatedKey || data?.qu_no || eqData?.qu_no || eqData?.eq_id;
            if (!key) {
                setPaymentHistory([]);
                return;
            }
            const response = await ExpenseServices.getPaymentByQuId(key);
            setPaymentHistory(response?.data || []);
        } catch (e) {
            console.error(e);
            setPaymentHistory([]);
        }
    };

    useEffect(() => {
        fetchPaymentHistory();
    }, [invoiceQuNo, generatedKey, data?.qu_no, eqData?.qu_no, eqData?.eq_id, invoice_no, invoiceRecord?.status, invoiceRecord?.id]);

    const [activityLog, setActivityLog] = useState([]);

    const fetchActivityLog = async () => {
        try {
            const key = invoice_no || invoiceQuNo || generatedKey || data?.qu_no || eqData?.qu_no || eqData?.eq_id;
            if (!key) {
                setActivityLog([]);
                return;
            }
            const res = await InvoiceService.getActivityLog(key);
            setActivityLog(res?.data || []);
        } catch (e) {
            console.error(e);
            setActivityLog([]);
        }
    };

    useEffect(() => {
        fetchActivityLog();
    }, [invoiceQuNo, generatedKey, data?.qu_no, eqData?.qu_no, eqData?.eq_id, invoice_no, invoiceRecord?.status, invoiceRecord?.id]);

    // A "full payment" record is a single payment whose paid_amt covers the grand total
    const isFullPaymentHistory = paymentHistory.length === 1 && Number(paymentHistory[0]?.paid_amt || 0) >= Number(grandTotal || 0);

    const totalReceived = paymentHistory.reduce((sum, p) => sum + Number(p.paid_amt || 0), 0);

    // Bubble payment summary numbers up to the parent (CreateInvoice/ViewInvoice) so the
    // "Payment Summary" card there can show real values instead of hardcoded ₹0.00
    useEffect(() => {
        if (onPaymentSummaryChange) {
            onPaymentSummaryChange({ grandTotal, totalReceived });
        }
    }, [grandTotal, totalReceived]);

    // Show all activity, each entry already carries performed_by_name to display who did it.
    const filteredActivityLog = activityLog;

    const [attachments, setAttachments] = useState([]);
    const [pendingFiles, setPendingFiles] = useState([]); // selected but not yet uploaded
    const [uploadingAttachments, setUploadingAttachments] = useState(false);

    const getAttachmentKey = () => invoice_no || invoiceQuNo || generatedKey || data?.qu_no || eqData?.qu_no || eqData?.eq_id;

    const fetchAttachments = async () => {
        try {
            const key = getAttachmentKey();
            if (!key) {
                setAttachments([]);
                return;
            }
            const response = await InvoiceService.getAttachments(key);
            setAttachments(response?.data || []);
        } catch (e) {
            console.error(e);
            setAttachments([]);
        }
    };

    useEffect(() => {
        fetchAttachments();
    }, [invoiceQuNo, generatedKey, data?.qu_no, eqData?.qu_no, eqData?.eq_id, invoice_no]);

    const handleSaveAttachments = async () => {
        const key = getAttachmentKey();
        if (!key) {
            message.warning("Please generate the invoice first before uploading attachments.");
            return;
        }
        if (pendingFiles.length === 0) {
            message.warning("Please select file(s) to upload first.");
            return;
        }
        try {
            setUploadingAttachments(true);
            const user = await UserService.getOmeUser();
            for (const f of pendingFiles) {
                await InvoiceService.uploadAttachment(key, f.originFileObj, user.uid);
            }
            message.success("Attachment(s) saved successfully!");
            setPendingFiles([]);
            await fetchAttachments();
        } catch (e) {
            console.error(e);
            message.error("Failed to save attachment(s)");
        } finally {
            setUploadingAttachments(false);
        }
    };

    const handleDeleteAttachment = async (id) => {
        try {
            const request = await InvoiceService.deleteAttachment(id);
            if (request?.status) {
                message.success("Attachment deleted");
                fetchAttachments();
            } else {
                message.error(request?.message || "Failed to delete attachment");
            }
        } catch (e) {
            console.error(e);
            message.error("Something went wrong while deleting attachment");
        }
    };


    const handleSearch = (value) => {
        setOptions(
            value
                ? taxOptions.map((tax) => ({ value: tax }))
                : []
        );
    };

    const handlePreview = () => {
        if (selectedValue) {
            setIsModalOpen(true);
        }
    };

    const getAllLetterhead = async () => {
        try {
            const request = await LetterService.getAllHead();
            const options = request.data.map((item) => ({
                label: item.tag,
                value: item.id,
                ...item,
            }));
            setLetterHead(options);

            if (data?.header_id) {
                const defaultHeader = options.find((option) => option.value === Number(data.header_id));
                if (defaultHeader) {
                    setSelectedOption(defaultHeader);
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    const getBankAcOption = async () => {
        try {
            const request = await BankService.getAllBank();
            const options = request.data.map((item) => ({
                label: item.tag,
                value: item.id,
                ...item,
            }));
            setBankAcOption(options);

            const bankIdToUse = invoiceRecord?.bank_id ?? data?.bank_id;
            if (bankIdToUse) {
                const defaultBank = options.find((option) => option.value === Number(bankIdToUse));
                if (defaultBank) {
                    setBankAc(defaultBank);
                    footerForm.setFieldsValue({ bank_ac: defaultBank.value });
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    const getAllTCData = async () => {
        try {
            const response = await LetterService.getAllTC();
            const options = response.data.map((item) => ({
                label: item.tag,
                value: item.id,
                ...item,
            }));
            setSelectedTCOption(options);

            const tcIdToUse = invoiceRecord?.tc_id ?? data?.tc_id;
            if (tcIdToUse) {
                const defaultTC = options.find((option) => option.value === Number(tcIdToUse));
                if (defaultTC) {
                    setSelectedValue(defaultTC);
                } else if (invoiceRecord?.tc_content) {
                    // TC record may have been deleted/changed; still show saved content
                    setSelectedValue({ value: undefined, data: invoiceRecord.tc_content });
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    const getDigitalSign = async () => {
        try {
            const response = await QuotationService.getDigitalSign();
            const options = response.data.map((item) => ({
                label: (
                    <img
                        src={`${ENDPOINT.base}/${item.image_path}`}
                        alt={`Signature ${item.id}`}
                        style={{ width: "100px", height: "auto", objectFit: "contain" }}
                    />
                ),
                value: item.id,
                title: `Signature ${item.id}`,
                ...item,
            }));
            setDGsignOption(options);

            if (data?.sign_id) {
                const defaultSign = options.find((option) => option.value === Number(data.sign_id));
                if (defaultSign) {
                    setDGsign(defaultSign);
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    const buildDescOptions = async () => {
        try {
            const [prodRes, servRes, catRes] = await Promise.all([
                ServicetypeService.getAllProducts(),
                ServicetypeService.getAllServices(),
                ServicetypeService.getAllProductCat(),
            ]);
            const products = prodRes?.data || [];
            const services = servRes?.data || [];
            const cats = catRes?.data || [];

            const catMap = {};
            cats.forEach((c) => { catMap[String(c.id)] = c.name; });
            const prodGroups = {};
            products.forEach((p) => {
                const catName = catMap[String(p.cat_id)] || "Uncategorized";
                if (!prodGroups[catName]) prodGroups[catName] = [];
                prodGroups[catName].push({
                    label: `${p.name}${p.sku ? ` (${p.sku})` : ""}`,
                    value: `prod-${p.id}`,
                    desc: p.name,
                    hsn: p.sku || "",
                    unit: p.unit || "",
                    price: Number(p.unit_price) || 0,
                    kind: "Product",
                    catName,
                    title: `Product: ${p.name}\nHSN/SAC: ${p.sku || "-"}\nUnit: ${p.unit || "-"}\nCategory: ${catName}\nUnit Price: ${p.unit_price || 0}`,
                });
            });

            const productOptionGroups = Object.keys(prodGroups).map((catName) => ({
                label: `Product — ${catName}`,
                options: prodGroups[catName],
            }));
            const serviceOptions = {
                label: "Services",
                options: services.map((s) => ({
                    label: `${s.service_name}${s.service_code ? ` (${s.service_code})` : ""}`,
                    value: `serv-${s.id}`,
                    desc: s.service_name,
                    hsn: "",
                    unit: "",
                    price: Number(s.unit_price) || 0,
                    kind: "Service",
                    title: `Service: ${s.service_name}\nCode: ${s.service_code || "-"}\nUnit Price: ${s.unit_price || 0}`,
                })),
            };

            setDescOptions([...productOptionGroups, serviceOptions]);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        getAllLetterhead();
        getAllTCData();
        getBankAcOption();
        getDigitalSign();
        buildDescOptions();
        form.setFieldsValue({
            quotationNo: data?.quotationNo,
            gstNo: data?.cus_gst,
            tax_id: data?.tax_id,
            tax_type: data?.tax_type
        });

        if (data?.bank_id) {
            footerForm.setFieldsValue({
                bank_ac: Number(data.bank_id),
            });
        }
    }, [data, invoiceRecord, form, footerForm]);
    useEffect(() => {

        const dataWithKeys = rowData.map((item, index) => ({
            ...item,
            key: item.key ?? (item.id ?? `temp_${index}`),
            description: item.description || item.service_name || "",
            discount: item.discount ?? 0,
            unit: item.unit || "Nos",
        })).map((item) => ({ ...item, ...computeRowAmounts(item) }));

        if (dataWithKeys.length > 0) {

            setDataSource(dataWithKeys);

            const maxKey = dataWithKeys.reduce((max, item) => {
                const itemKey = Number(item.key);
                return isNaN(itemKey) ? max : Math.max(max, itemKey);
            }, 0);
            setCount(maxKey + 1);
        }
    }, [rowData]);

    useEffect(() => {
        if (invoiceDate) {
            setSelectedDate(dayjs(invoiceDate).format("YYYY-MM-DD"));
            if (!form.getFieldValue("invoice_date")) {
                form.setFieldsValue({ invoice_date: dayjs(invoiceDate) });
            }
        } else if (data?.invoice_date) {
            setSelectedDate(data.invoice_date);
            if (!form.getFieldValue("invoice_date")) {
                form.setFieldsValue({ invoice_date: dayjs(data.invoice_date) });
            }
        }

        if (invoiceScope !== undefined && invoiceScope !== null) {
            setScope(invoiceScope);
        } else {
            setScope("");
        }
    }, [invoiceDate, data?.invoice_date, invoiceScope]);

    useEffect(() => {
        if (invoiceRecord?.notes) {
            setSavedNote(invoiceRecord.notes);
        }
        if (invoiceRecord?.payment_notes) {
            setTabSavedNote(invoiceRecord.payment_notes);
        }
    }, [invoiceRecord]);
const importedEqRef = React.useRef(null);

    useEffect(() => {

        if (!eqData || rowData?.length > 0) {
            return;
        }
        if (isInvoiceCreated) {
            return;
        }

        const currentEqKey = eqData?.eq_id || eqData?.qu_no;
        if (!currentEqKey || importedEqRef.current === currentEqKey) {
            return;
        }

        const parseItems = (items) => {
            if (Array.isArray(items)) return items;
            try {
                return JSON.parse(items || "[]");
            } catch {
                return [];
            }
        };

        const serviceItems = parseItems(eqData.service_items);
        const productItems = parseItems(eqData.product_items);

        const serviceRows = serviceItems.map((item, index) => {
            const base = {
                key: `service-${index}`,
                description: item.service_name || "",
                qty: 1,
                hsn_code: "",
                unit: item.unit || "Nos",
                unitprice: Number(item.unit_price || 0),
                discount: 0,
                tax: 0,
            };
            return { ...base, ...computeRowAmounts(base) };
        });

        const productRows = productItems.map((item, index) => {
            const base = {
                key: `product-${index}`,
                description: item.product_name || "",
                qty: 1,
                hsn_code: item.hsn_code || item.sku || item.code_name || "",
                unit: item.unit || "Nos",
                unitprice: Number(item.unit_price || 0),
                discount: 0,
                tax: 0,
            };
            return { ...base, ...computeRowAmounts(base) };
        });

        const rows = [...serviceRows, ...productRows];

        if (rows.length > 0) {
            setDataSource(rows);
            setCount(rows.length + 1);
        }

        importedEqRef.current = currentEqKey;
    }, [eqData, rowData?.length, isInvoiceCreated]);

    const numberToWords = (num) => {
        const a = [
            "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
            "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
        ];
        const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
        const g = ["", "Thousand", "Million", "Billion"];

        if (num === 0) return "Zero";

        let str = "";
        let grp = 0;

        while (num > 0) {
            let chunk = num % 1000;
            if (chunk) {
                let chunkStr = "";
                if (chunk > 99) {
                    chunkStr += a[Math.floor(chunk / 100)] + " Hundred ";
                    chunk %= 100;
                }
                if (chunk > 19) {
                    chunkStr += b[Math.floor(chunk / 10)] + " ";
                    chunk %= 10;
                }
                if (chunk > 0) chunkStr += a[chunk] + " ";
                str = chunkStr + g[grp] + " " + str;
            }
            num = Math.floor(num / 1000);
            grp++;
        }
        return str.trim();
    };

    // Computes taxable_amount, tax_amount, totalprice for a row based on qty/unitprice/discount/tax
    const computeRowAmounts = (item) => {
        const qty = Number(item.qty || 0);
        const rate = Number(item.unitprice || 0);
        const discountPercent = Number(item.discount || 0);
        const taxPercent = Number(item.tax || 0);

        const base = qty * rate;
        const discountAmount = (base * discountPercent) / 100;
        const taxableAmount = base - discountAmount;
        const taxAmount = (taxableAmount * taxPercent) / 100;
        const total = taxableAmount + taxAmount;

        return {
            taxable_amount: Math.round(taxableAmount),
            tax_amount: Math.round(taxAmount),
            totalprice: Math.round(total),
        };
    };

    useEffect(() => {
        calculateGrandTotal();
    }, [dataSource, overallDiscount]);

    useEffect(() => {
        setPrintCount(data?.print_count || 0);
    }, [data]);

    const handleDelete = async (record) => {
        // Before the invoice exists, dataSource rows (when sourced from a
        // quotation/enquiry) still carry the ORIGINAL quotation_data row IDs.
        // Deleting by ID at this stage would delete the row straight out of
        // the source quotation's data — not what we want. Just remove it
        // locally; it will simply be excluded from formattedData when the
        // invoice is generated (fresh copies are inserted without these IDs).
        if (record.id && isInvoiceCreated) {
            try {
                const request = await QuotationService.deleteQuotation(record.id);
                if (request.status) {
                    const newData = dataSource.filter((item) => item.id !== record.id);
                    setDataSource(newData);
                    message.success(request.message);
                } else {
                    message.error(request.message);
                }
            } catch (error) {
                console.error(error);
                message.error("Failed to delete row");
            }
        } else {
            const newData = dataSource.filter((item) => (item.id ?? item.key) !== (record.id ?? record.key));
            setDataSource(newData);
            message.success("Row deleted");
        }
    };

    const handleSelectDesc = (rowKey, selectedValue, option) => {
        const newData = dataSource.map((item) => {
            const itemKey = item.id ?? item.key;
            if (itemKey === rowKey) {
                const updated = {
                    ...item,
                    description: option?.desc ?? item.description,
                    hsn_code: option?.hsn ?? item.hsn_code,
                    unit: option?.unit ?? item.unit,
                    unitprice: option?.price ?? item.unitprice,
                };
                return { ...updated, ...computeRowAmounts(updated) };
            }
            return item;
        });
        setDataSource(newData);
    };

    const handleChange = (key, field, value) => {
        const newData = dataSource.map((item) => {
            if ((item.id ?? item.key) === key) {
                const updatedItem = { ...item, [field]: value };
                return { ...updatedItem, ...computeRowAmounts(updatedItem) };
            }
            return item;
        });
        setDataSource(newData);
    };

    const subTotal = dataSource.reduce((sum, item) => sum + Number(item.qty || 0) * Number(item.unitprice || 0), 0);
    const taxableAmountTotal = dataSource.reduce((sum, item) => sum + Number(item.taxable_amount || 0), 0) - Number(overallDiscount || 0);
    const taxAmountTotal = dataSource.reduce((sum, item) => sum + Number(item.tax_amount || 0), 0);
    const cgstTotal = taxAmountTotal / 2;
    const sgstTotal = taxAmountTotal / 2;

    const calculateGrandTotal = () => {
        const total = taxableAmountTotal + taxAmountTotal;
        setGrandTotal(Math.round(total));
    };

    const getFilteredDescOptions = () => {
        const q = (descSearch || "").toLowerCase().trim();
        if (!q) return descOptions;
        return descOptions
            .map((group) => {
                const opts = (group.options || []).filter((o) => {
                    const label = String(o.label || "").toLowerCase();
                    const hsn = String(o.hsn || "").toLowerCase();
                    return label.includes(q) || hsn.includes(q);
                });
                return { ...group, options: opts };
            })
            .filter((group) => (group.options || []).length > 0);
    };

    const columns = [
        {
            title: "#",
            dataIndex: "key",
            width: 35,
            align: "center",
            key: "key",
            render: (_, __, index) => index + 1,
        },
        {
            title: "Item / Service",
            dataIndex: "description",
            key: "item_service",
            width: 200,
            render: (text, record) => (
                <AutoComplete
                    style={{ width: "100%" }}
                    options={getFilteredDescOptions()}
                    value={text}
                    placeholder="Type product / service"
                    filterOption={false}
                    onSearch={(val) => setDescSearch(val)}
                    onFocus={() => setDescSearch("")}
                    onSelect={(val, option) => {
                        setDescSearch("");
                        handleSelectDesc(record.id ?? record.key, val, option);
                    }}
                    onChange={(val) => {
                        setDescSearch(val);
                        handleChange(record.id ?? record.key, "description", val);
                    }}
                >
                    <TextArea
                        value={text}
                        autoSize={{ minRows: 1, maxRows: 3 }}
                        style={{ resize: "none", fontSize: 13 }}
                    />
                </AutoComplete>
            ),
        },
        {
            title: "Description",
            dataIndex: "item_description",
            key: "description_sub",
            width: 180,
            render: (text, record) => (
                <TextArea
                    value={record.item_description ?? ""}
                    autoSize={{ minRows: 1, maxRows: 3 }}
                    placeholder="Description"
                    style={{ resize: "none", fontSize: 13 }}
                    onChange={(e) => handleChange(record.id ?? record.key, "item_description", e.target.value)}
                />
            ),
        },
        {
            title: "Qty",
            dataIndex: "qty",
            width: 55,
            align: "center",
            key: "qty",
            render: (text, record) => (
                <InputNumber
                    size="small"
                    min={0}
                    controls={false}
                    value={text}
                    style={{ width: "100%", height: 30 }}
                    onChange={(value) => handleChange(record.id ?? record.key, "qty", value)}
                />
            ),
        },
        {
            title: "Unit",
            dataIndex: "unit",
            width: 60,
            align: "center",
            key: "unit",
            render: (text, record) => (
                <Input
                    size="small"
                    value={text}
                    style={{ height: 30 }}
                    onChange={(e) => handleChange(record.id ?? record.key, "unit", e.target.value)}
                />
            ),
        },
        {
            title: "Rate (₹)",
            dataIndex: "unitprice",
            align: "right",
            width: 80,
            key: "unitprice",
            render: (text, record) => (
                <InputNumber
                    size="small"
                    min={0}
                    controls={false}
                    value={text}
                    style={{ width: "100%", height: 30 }}
                    onChange={(value) => handleChange(record.id ?? record.key, "unitprice", value)}
                />
            ),
        },
        {
            title: "Discount (%)",
            dataIndex: "discount",
            width: 80,
            align: "center",
            key: "discount",
            render: (text, record) => (
                <InputNumber
                    size="small"
                    min={0}
                    max={100}
                    controls={false}
                    value={text}
                    style={{ width: "100%", height: 30 }}
                    onChange={(value) => handleChange(record.id ?? record.key, "discount", value)}
                />
            ),
        },
        {
            title: "Taxable Amount (₹)",
            dataIndex: "taxable_amount",
            align: "right",
            width: 110,
            key: "taxable_amount",
            render: (text) => (
                <Typography.Text style={{ fontSize: 13 }}>
                    {Number(text || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                </Typography.Text>
            ),
        },
        {
            title: "Tax (%)",
            dataIndex: "tax",
            width: 65,
            align: "center",
            key: "tax",
            render: (text, record) => (
                <InputNumber
                    size="small"
                    min={0}
                    controls={false}
                    value={text}
                    style={{ width: "100%", height: 30 }}
                    onChange={(value) => handleChange(record.id ?? record.key, "tax", value)}
                />
            ),
        },
        {
            title: "Tax Amount (₹)",
            dataIndex: "tax_amount",
            align: "right",
            width: 100,
            key: "tax_amount",
            render: (text) => (
                <Typography.Text style={{ fontSize: 13 }}>
                    {Number(text || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                </Typography.Text>
            ),
        },
        {
            title: "Amount (₹)",
            dataIndex: "totalprice",
            align: "right",
            width: 100,
            key: "totalprice",
            render: (text) => (
                <Typography.Text strong style={{ fontSize: 13 }}>
                    {Number(text || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                </Typography.Text>
            ),
        },
        {
            title: "Action",
            key: "action",
            align: "center",
            width: 60,
            render: (_, record) => (
                <Space size={0}>
                    <Button
                        disabled={!Eqslected}
                        icon={<DeleteOutlined />}
                        type="text"
                        danger
                        size="small"
                        onClick={() => handleDelete(record)}
                    />
                </Space>
            ),
        },
    ];

    const handleNewAdd = () => {
        const newRow = {
            key: count,
            description: "",
            qty: 1,
            unit: "Nos",
            unitprice: 0,
            discount: 0,
            tax: 0,
        };
        setDataSource([...dataSource, { ...newRow, ...computeRowAmounts(newRow) }]);
        setCount(count + 1);
    };

    const handleAdd = (identifier) => {
        const newRow = { key: count, description: "", qty: 1, unit: "Nos", unitprice: 0, discount: 0, tax: 18 };
        const index = dataSource.findIndex((item) => item.id === identifier || item.key === identifier);

        let newData = [...dataSource];
        newData.splice(index + 1, 0, { ...newRow, ...computeRowAmounts(newRow) });
        setDataSource(newData);
        setCount(count + 1);
    };

    const handleSave = async () => {
        try {
            if (!dataSource || dataSource.length <= 0) {
                return message.warning("Please Add contents");
            }

            const request = form.getFieldsValue();

            const quKey = invoiceQuNo || generatedKey || data?.qu_no || eqData?.qu_no || eqData?.eq_id;
            if (!quKey) {
                return message.warning("Please generate the invoice first before updating.");
            }

            const formattedData = dataSource.map(({ key, ...rest }) => ({
                ...rest,
                qu_no: quKey
            }));

            const user = await UserService.getOmeUser();

            const data_insert = {
                tax_id: request?.tax_id,
                tax_type: request?.tax_type,
                tc_id: selectedValue?.id ?? null,
                sign_id: dgSign?.id ?? null,
                added_by: user.uid,
                bank_id: bankAc?.value ?? null,
                notes: savedNote || null,                    // already there
                payment_notes: tabSavedNote || null,
            };

const requests_1 = await QuotationService.patchQuotation(quKey, data_insert);
            const requests = await InvoiceService.updateQUotationRow(formattedData);
            if (invoiceId) {
                try { await InvoiceService.recalcInvoiceTotal(quKey); } catch (e) { console.error(e); }
            }

            if (invoiceId) {
                const invoiceDateToSend = request.invoice_date
                    ? dayjs(request.invoice_date).format("YYYY-MM-DD")
                    : (invoiceDate || null); // fall back to the prop instead of nulling it out

                await InvoiceService.updateInvoice(
                    {
                        scope: scope || null,
                        invoice_date: invoiceDateToSend,
                        tc_id: selectedValue?.id ?? null,
                        tc_content: selectedValue?.data ?? null,
                        bank_id: bankAc?.value ?? null,
                        sign_id: dgSign?.id ?? null,
                        notes: savedNote || null,
                        payment_notes: tabSavedNote || null,
                    },
                    invoiceId
                );
            }
            if (requests.status) {
                message.success(requests.message);
                const getRowData = await QuotationService.getAllQuotationById(quKey);
                const freshRows = getRowData.data.quotation_data || [];
                setDataSource(freshRows.map((item, index) => ({
                    ...item,
                    key: item.id ?? `temp_${index}`,
                    description: item.description || item.service_name || "",
                    discount: item.discount ?? 0,
                    unit: item.unit || "Nos",
                    ...computeRowAmounts(item),
                })));
                if (onInvoiceGenerated) {
                    onInvoiceGenerated((prev) => ({
                        ...(prev || {}),
                        tc_id: selectedValue?.id ?? null,
                        tc_content: selectedValue?.data ?? null,
                        bank_id: bankAc?.value ?? null,
                        sign_id: dgSign?.id ?? null,
                        notes: savedNote || null,
                        payment_notes: tabSavedNote || null,
                    }));
                }
            } else {
                message.error(requests.message);
                const getRowData = await QuotationService.getAllQuotationById(quKey);
                const freshRows = getRowData.data.quotation_data || [];
                setDataSource(freshRows.map((item, index) => ({
                    ...item,
                    key: item.id ?? `temp_${index}`,
                    description: item.description || item.service_name || "",
                    discount: item.discount ?? 0,
                    unit: item.unit || "Nos",
                    ...computeRowAmounts(item),
                })));
            }
        } catch (error) {
            console.error(error);
        }
    };
    const handleAddPayment = async () => {
        try {
            const key = invoice_no || invoiceQuNo || generatedKey || data?.qu_no || eqData?.qu_no || eqData?.eq_id;
            setQuotationNo(key);
            setPaymentModalOpen(true);
        } catch (error) {
            console.error("Error in handleAddPayment:", error);
        }
    };
    const handleGenerateInvoice = async () => {
        if (generatingInvoice) return;
        setGeneratingInvoice(true);
        try {
            const request = form.getFieldsValue();
            const finalInvoiceDate = request.invoice_date
                ? dayjs(request.invoice_date).format("YYYY-MM-DD")
                : invoiceDate || selectedDate;

            if (!finalInvoiceDate) {
                return message.warning("Please select invoice date")
            }
            const user = await UserService.getOmeUser();
            const quNo = data?.qu_no || eqData?.qu_no;
            const enquiryId = eqData?.eq_id;

            let to_insert = {
                invoice_date: finalInvoiceDate,
                status: "Draft",
                invoice_no: invoice_no,
                scope: scope || null,
                added_by: user.uid,
                tc_id: selectedValue?.id ?? null,
                tc_content: selectedValue?.data ?? null,
                bank_id: bankAc?.value ?? null,
                notes: savedNote || null,
                payment_notes: tabSavedNote || null,
                due_date: extraDetails?.due_date || null,
                reference: extraDetails?.reference || null,
                project: extraDetails?.project || null,
                place_of_supply: extraDetails?.place_of_supply || null,
                sales_executive: extraDetails?.sales_executive || null,
            };
            if (quNo) {
                if (!dataSource || dataSource.length <= 0) {
                    return message.warning("Please Add contents");
                }
                // Each invoice needs its OWN key — don't reuse the quotation's
                // qu_no, or every invoice generated from the same quotation
                // collides into the same row / line items / payments.
                // Keep the ORIGINAL quotation number as source_qu_no so the
                // backend can insert formattedData and remember where it came from.
                to_insert.qu_no = invoice_no;
                to_insert.source_qu_no = quNo;
                to_insert.formattedData = dataSource.map(({ key, id, ...rest }) => ({ ...rest }));
            } else if (enquiryId) {
                if (!dataSource || dataSource.length <= 0) {
                    return message.warning("Please Add contents");
                }
                to_insert.qu_no = invoice_no;
                to_insert.eq_id = enquiryId;
                to_insert.formattedData = dataSource.map(({ key, id, ...rest }) => ({ ...rest }));
            } else {
                if (!dataSource || dataSource.length <= 0) {
                    return message.warning("Please Add contents");
                }
                const rawCustomer = customerForm ? customerForm.getFieldsValue() : {};
                to_insert.customer_data = {
                    ...rawCustomer,
                    name: rawCustomer.name || customerInfo?.company_name || customerInfo?.contact_person || "",
                    mobile_no: rawCustomer.mobile_no || customerInfo?.mobile_no || "",
                    address: rawCustomer.address || customerInfo?.address || "",
                    gstin: rawCustomer.gstin || customerInfo?.gstin || "",
                    email: rawCustomer.email || customerInfo?.email || "",
                };
                to_insert.formattedData = dataSource.map(({ key, id, ...rest }) => ({ ...rest }));
            }

            const createInvoice = await InvoiceService.createInvoice(to_insert);

            if (createInvoice.status) {
                message.success(createInvoice.message);
                setPrintInvoice(true);
                const key = to_insert.qu_no || invoice_no;
                setGeneratedKey(key);
                if (onInvoiceGenerated) onInvoiceGenerated(createInvoice.data);

                try {
                    const getRowData = await QuotationService.getAllQuotationById(key);
                    if (getRowData?.data?.quotation_data) {
                        const seenIds = new Set();
                        const deduped = getRowData.data.quotation_data.filter((item) => {
                            if (!item.id) return true;
                            if (seenIds.has(item.id)) return false;
                            seenIds.add(item.id);
                            return true;
                        });
                        const withKeys = deduped.map((item, index) => ({
                            ...item,
                            key: item.id ?? `temp_${index}`,
                            description: item.description || item.service_name || "",
                            discount: Number(item.discount ?? 0),
                            unit: item.unit || "Nos",
                            qty: Number(item.qty || 0),
                            unitprice: Number(item.unitprice || 0),
                            tax: Number(item.tax || 0),
                        })).map((item) => ({ ...item, ...computeRowAmounts(item) }));
                        setDataSource(withKeys);
                    }
                } catch (e) {
                    console.error(e);
                }
            } else {
                message.error(createInvoice.message);
            }
        } finally {
            setGeneratingInvoice(false);
        }
    };

    const getBase64Image = (url) =>
        new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = "Anonymous";
            img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                resolve(canvas.toDataURL("image/png"));
            };
            img.onerror = reject;
            img.src = url;
        });

    const handlePrintInvoice = async (qu_no, templateType = "v1") => {
        try {
            const quotationRes = await QuotationService.getAllQuotationById(qu_no);
            const quotation = quotationRes?.data?.quotation;

            let enquiry;
            const hasQuotation = quotation && quotation.qu_no;
            const isManual = hasQuotation && quotation?.eq_no === quotation?.qu_no;

            if (isManual) {
                const cust = quotationRes?.data?.customer || {};
                enquiry = {
                    name: cust.name || "-",
                    address: cust.address || "-",
                    mobile_no: cust.mobile_no || "-",
                    currency: "INR",
                };
            } else if (!hasQuotation) {
                const enquiryRes = await EnquiryService.getEnquiryDetailsById(qu_no);
                enquiry = enquiryRes?.data || { name: "-", address: "-", mobile_no: "-", currency: "INR" };
            } else {
                const enquiryRes = await EnquiryService.getEnquiryDetailsById(quotation.eq_no);
                enquiry = enquiryRes?.data;
            }

            if (!quotation) {
                message.error("Data not found!");
                return;
            }

            const invoiceDataForPDF = dataSource.map((item) => ({
                description: item.description || "",
                qty: item.qty || 0,
                unitprice: item.unitprice || 0,
                tax: item.tax || 0,
                totalprice: item.totalprice || 0,
            }));

            const headerImageObj = letterHead.find((lh) => lh.tag.toLowerCase() === "header");
            const footerImageObj = letterHead.find((lh) => lh.tag.toLowerCase() === "footer");
            const watermarkObj = letterHead.find((lh) => lh.tag.toLowerCase() === "watermark");

            const headerBase64 = headerImageObj ? await getBase64Image(`${ENDPOINT.base}/${headerImageObj.image_url}`) : "";
            const footerBase64 = footerImageObj ? await getBase64Image(`${ENDPOINT.base}/${footerImageObj.image_url}`) : "";
            const dgSignBase64 = dgSign ? await getBase64Image(`${ENDPOINT.base}/${dgSign.image_path}`) : "";
            const watermarkBase64 = watermarkObj ? await getBase64Image(`${ENDPOINT.base}/${watermarkObj.image_url}`) : "";

            const templateProps = {
                headerBase64,
                footerBase64,
                dgSignBase64,
                watermarkBase64,
                quotation,
                enquiry,
                quotationData: invoiceDataForPDF,
                invoice_date: new Date(),
                invoice_no,
                grandTotal,
                numberToWords,
                selectedValue,
                bankAc,
                type: "INVOICE",
                tax_type: form.getFieldValue("tax_type"),
                tax_id: form.getFieldValue("tax_id"),
                currency: enquiry.currency,
            };

            const pdfDoc =
                templateType === "v2"
                    ? QuotationInvoiceTemplateV2(templateProps)
                    : QuotationInvoiceTemplate(templateProps);

            pdfDoc.save(`${invoice_no}.pdf`);

            setPrintCount((prev) => prev + 1);

            await InvoiceService.updateInvoice({ print_count: printCount + 1 }, invoiceId);
        } catch (error) {
            console.error(error);
            message.error("Failed to generate PDF!");
        }
    };

    const handleClear = async () => {
        setDataSource([]);
        setBankAc(null);
        footerForm.resetFields();
    };

    return (
        <>
            <style>{`
     .scope-quill .quill {
    border: none;
    background: #fff;
}

.ant-table-cell .ant-input-number-input {
    height: 28px !important;
    padding: 0 8px !important;
}
.ant-table-cell .ant-input {
    height: 30px !important;
}
          .scope-quill .ql-toolbar.ql-snow {
            border: none;
            border-bottom: 1px solid #f0f0f0;
            background: #fafafa;
            padding: 8px 12px;
          }
          .scope-quill .ql-container.ql-snow {
            border: none;
            font-size: 14px;
          }
          .scope-quill .ql-editor {
            min-height: 220px;
            padding: 14px 16px;
            line-height: 1.6;
          }
          .scope-quill .ql-editor.ql-blank::before {
            left: 16px;
            color: #bfbfbf;
            font-style: normal;
          }
          .ant-collapse-content-box:has(.scope-quill) {
            padding: 12px !important;
          }
        `}</style>
            {msgContc}

            {/* <Form form={form} layout="vertical" style={{ width: "100%" }}>
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12} md={8}>
                        <Form.Item label="Invoice Date" name="invoice_date" style={{ width: "100%" }}>
                            <DatePicker
                                style={{ width: "100%" }}
                                size="large"
                                format="DD-MM-YYYY"
                                onChange={(date) => {
                                    if (date) {
                                        setSelectedDate(dayjs(date).format("YYYY-MM-DD"));
                                    } else {
                                        setSelectedDate(null);
                                    }
                                }}
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                        <Form.Item label="Tax type" name="tax_type" initialValue={data?.tax_type} style={{ width: "100%" }}>
                            <AutoComplete
                                allowClear
                                style={{ width: "100%" }}
                                options={options}
                                onSearch={handleSearch}
                                placeholder="Enter Tax type (e.g. GST, VAT)"
                                size="large"
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8}>
                        <Form.Item label="Tax ID" name="tax_id" initialValue={data?.tax_id} style={{ width: "100%" }}>
                            <Input allowClear placeholder="Enter Tax ID (e.g. 09AAACH7409R1ZZ)" size="large" />
                        </Form.Item>
                    </Col>
                </Row>
            </Form> */}

            <Card style={{ marginTop: '20px' }} bodyStyle={{ padding: 16 }}>
                {/* Invoice Items header — matches the image */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 14,
                        flexWrap: "wrap",
                        gap: 10,
                    }}
                >
                    <Typography.Text strong style={{ color: primaryColor, fontSize: 15 }}>
                        Invoice Items
                    </Typography.Text>

                    <Space wrap>
                        <Button
                            disabled={!Eqslected}
                            icon={<PlusOutlined />}
                            type="primary"
                            size="small"
                            onClick={handleNewAdd}
                            style={{ backgroundColor: primaryColor, borderColor: primaryColor }}
                        >
                            Add Item
                        </Button>
                        <Button disabled={!Eqslected} icon={<CommentOutlined />} size="small">
                            Add Comment
                        </Button>
                    </Space>
                </div>
                <Table
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                    rowKey="key"
                    size="small"
                    tableLayout="fixed"
                    scroll={{ x: "max-content" }}
                />

                <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
                    <Col xs={24} md={12}>
                        <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 6 }}>
                            Amount in Words
                        </div>
                        <div style={{ fontSize: 13, fontWeight: 600, color: "#1f1f1f" }}>
                            Rupees {numberToWords(grandTotal)} Only
                        </div>
                    </Col>

                    <Col xs={24} md={12}>
                        <div style={{ maxWidth: 360, marginLeft: "auto" }}>
                            <SummaryRow label="Sub Total" value={subTotal} />
                            <SummaryRow
                                label="Discount"
                                value={overallDiscount}
                                editable
                                onChange={(v) => setOverallDiscount(v || 0)}
                            />
                            <SummaryRow label="Taxable Amount" value={taxableAmountTotal} />
                            <SummaryRow label={`CGST (${dataSource[0]?.tax ? dataSource[0].tax / 2 : 0}%)`} value={cgstTotal} />
                            <SummaryRow label={`SGST (${dataSource[0]?.tax ? dataSource[0].tax / 2 : 0}%)`} value={sgstTotal} />

                            <Divider style={{ margin: "10px 0" }} />

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    background: "#eef4fb",
                                    padding: "10px 12px",
                                    borderRadius: 8,
                                }}
                            >
                                <Typography.Text strong style={{ fontSize: 14 }}>
                                    Grand Total
                                </Typography.Text>
                                <Typography.Text strong style={{ fontSize: 16, color: primaryColor }}>
                                    ₹ {Number(grandTotal || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                </Typography.Text>
                            </div>
                        </div>
                    </Col>
                </Row>

                {/* <Row style={{ display: "flex", gap: 16, marginTop: 24 }}>
                    <Col style={{ flex: 1, minWidth: 250 }}>
                        <Form form={footerForm} layout="vertical">
                            <Form.Item label="Select Terms & Condition" style={{ width: "100%" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                    <Select
                                        placeholder="Select option"
                                        options={selectedTCOption}
                                        size="large"
                                        value={selectedValue?.value}
                                        style={{ flex: 1 }}
                                        onChange={(value, option) => setSelectedValue(option)}
                                    />
                                    <Button type="link" onClick={handlePreview}>
                                        Preview
                                    </Button>
                                </div>

                                <Modal
                                    title="Preview of selected T&C"
                                    open={isModalOpen}
                                    footer={null}
                                    onCancel={() => setIsModalOpen(false)}
                                >
                                    {selectedValue?.data ? (
                                        <div
                                            style={{
                                                padding: "10px",
                                                border: "1px solid #f0f0f0",
                                                borderRadius: "8px",
                                                background: "#fafafa",
                                                minHeight: "100px",
                                            }}
                                            dangerouslySetInnerHTML={{ __html: selectedValue.data }}
                                        />
                                    ) : (
                                        <p>No data selected</p>
                                    )}
                                </Modal>
                            </Form.Item>
                        </Form>
                    </Col>

                    <Col style={{ flex: 1, minWidth: 250 }}>
                        <Form form={footerForm} layout="vertical">
                            <Form.Item
                                label="Select Bank Account"
                                name="bank_ac"
                                rules={[{ required: true, message: "Please select an option!" }]}
                            >
                                <Select
                                    placeholder="Select option"
                                    options={bankAcOption}
                                    value={bankAc?.value}
                                    size="large"
                                    style={{ width: "100%" }}
                                    onChange={(value, option) => setBankAc(option)}
                                />
                            </Form.Item>
                        </Form>
                    </Col>

                    <Col style={{ flex: 1, minWidth: 250 }}>
                        <Form layout="vertical">
                            <Form.Item
                                label="Second Digital signature"
                                name="dgselect"
                                rules={[{ required: true, message: "Please select an option!" }]}
                            >
                                <Select
                                    allowClear
                                    placeholder="Select option"
                                    options={dgSignOption}
                                    value={dgSign?.value}
                                    size="large"
                                    style={{ width: "100%" }}
                                    optionRender={(option) => option.data.label}
                                    fieldNames={{ label: "title", value: "value" }}
                                    onChange={(value, option) => setDGsign(option)}
                                />
                            </Form.Item>
                        </Form>
                    </Col>
                </Row> */}

                {/* <Row justify="end" style={{ marginTop: 16 }}>
                    <Divider />
                    <Space>
                        <Button disabled={!Eqslected} size="large" onClick={handleAddPayment}>
                            Add payment Amount
                        </Button>

                        <Popconfirm title="Sure to clear?" onConfirm={handleClear}></Popconfirm>

                        <Button disabled={!Eqslected} size="large" onClick={handleSave}>
                            Update
                        </Button>
                        <Button disabled={!Eqslected || viewMode} size="large" type="primary" onClick={handleGenerateInvoice}>
                            Generate Invoice
                        </Button>

                        <Space>
                            <Button
                                size="large"
                                disabled={viewMode ? false : !printInvoice}
                                type="primary"
                                onClick={() => {
                                    setSelectedPrintQuNo(data?.qu_no || eqData?.qu_no || eqData?.eq_id || invoice_no);
                                    setTemplateModalOpen(true);
                                }}
                            >
                                Print Invoice
                            </Button>

                            <Tooltip title={`Printed ${printCount} time${printCount !== 1 ? "s" : ""}`}>
                                <InfoCircleOutlined style={{ color: "#1677ff", fontSize: 18, cursor: "pointer" }} />
                            </Tooltip>
                        </Space>
                    </Space>
                </Row> */}

                <Modal
                    width={1100}
                    title={<Typography.Title level={4}>Add Payment for: {quotationNo}</Typography.Title>}
                    open={paymentModalOpen}
                    onCancel={() => {
                        setPaymentModalOpen(false);
                        fetchPaymentHistory();
                        fetchActivityLog();
                    }}
                    footer={null}
                    destroyOnClose
                >
                    {quotationNo && <CreatePayment quotationNo={quotationNo} grandTotal={grandTotal} />}
                </Modal>
            </Card>

            <Row gutter={[16, 16]} style={{ marginTop: 16 }} align="top">
                {/* LEFT: Payment History Tabs */}
                <Col xs={24} lg={10}>
                    <Card bodyStyle={{ padding: 0 }} style={{ borderRadius: 12 }}>
                        <Tabs
                            defaultActiveKey="payment_history"
                            style={{ padding: "0 16px" }}
                            items={[
                                {
                                    key: "payment_history",
                                    label: "Payment History",
                                    children: (
                                        <div style={{ padding: "0 0 16px" }}>
                                            <Table
                                                size="small"
                                                pagination={false}
                                                dataSource={paymentHistory.map((p, i) => ({ ...p, key: p.id ?? i }))}
                                                locale={{ emptyText: "No payments recorded yet" }}
                                                columns={[
                                                    { title: "#", width: 35, render: (_, __, i) => i + 1 },
                                                    {
                                                        title: "Payment Date", dataIndex: "payment_date",
                                                        render: (v) => v ? dayjs(v).format("DD MMM YYYY") : "-",
                                                    },
                                                    {
                                                        title: "Amount (₹)", dataIndex: "paid_amt", align: "right",
                                                        render: (v) => Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 }),
                                                    },
                                                    {
                                                        title: "Payment Mode", dataIndex: "pay_mode",
                                                        render: (v) => v || "-",
                                                    },
                                                    {
                                                        title: "Balance", dataIndex: "balance", align: "right",
                                                        render: (v) => Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 }),
                                                    },
                                                    { title: "Notes", dataIndex: "notes", render: (v) => v || "-" },
                                                ]}
                                            />
                                            {/* Total Received row */}
                                            <div style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                padding: "8px 0 0",
                                                borderTop: "1px solid #f0f0f0",
                                                marginTop: 8,
                                            }}>
                                                <Typography.Text strong style={{ fontSize: 13 }}>Total Received</Typography.Text>
                                                <Typography.Text strong style={{ fontSize: 13, color: "#16a34a" }}>
                                                    ₹ {totalReceived.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                </Typography.Text>
                                            </div>
                                        </div>
                                    ),
                                },
                                {
                                    key: "installments",
                                    label: "Installments",
                                    children: (
                                        <div style={{ padding: "0 0 16px" }}>
                                            {isFullPaymentHistory ? (
                                                <Typography.Text type="secondary" style={{ fontSize: 13 }}>
                                                    This invoice was paid in full as a single payment — no installments recorded.
                                                </Typography.Text>
                                            ) : (
                                                <Table
                                                    size="small"
                                                    pagination={false}
                                                    dataSource={paymentHistory.map((p, i) => ({ ...p, key: p.id ?? i }))}
                                                    locale={{ emptyText: "No installments added" }}
                                                    columns={[
                                                        { title: "#", width: 35, render: (_, __, i) => i + 1 },
                                                        {
                                                            title: "Date", dataIndex: "payment_date",
                                                            render: (v) => v ? dayjs(v).format("DD MMM YYYY") : "-",
                                                        },
                                                        {
                                                            title: "Amount (₹)", dataIndex: "paid_amt", align: "right",
                                                            render: (v) => Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 }),
                                                        },
                                                        { title: "Status", dataIndex: "status", render: (v) => v || "-" },
                                                        { title: "Notes", dataIndex: "notes", render: (v) => v || "-" },
                                                    ]}
                                                />
                                            )}
                                        </div>
                                    ),
                                },
                                {
                                    key: "attachments",
                                    label: "Attachments",
                                    children: (
                                        <div style={{ padding: "0 0 16px" }}>
                                            <Space style={{ marginBottom: 12 }} wrap>
                                                <Upload
                                                    multiple
                                                    fileList={pendingFiles}
                                                    beforeUpload={(file) => {
                                                        setPendingFiles((prev) => [
                                                            ...prev,
                                                            { uid: `${Date.now()}-${file.name}`, name: file.name, status: "done", originFileObj: file },
                                                        ]);
                                                        return false; // prevent auto-upload; we upload manually on Save
                                                    }}
                                                    onRemove={(file) => {
                                                        setPendingFiles((prev) => prev.filter((f) => f.uid !== file.uid));
                                                    }}
                                                >
                                                    <Button icon={<UploadOutlined />}>Select File(s)</Button>
                                                </Upload>
                                                <Button
                                                    type="primary"
                                                    style={{ backgroundColor: primaryColor, borderColor: primaryColor }}
                                                    loading={uploadingAttachments}
                                                    onClick={handleSaveAttachments}
                                                >
                                                    Save
                                                </Button>
                                            </Space>

                                            {attachments.length === 0 ? (
                                                <Typography.Text type="secondary" style={{ fontSize: 13 }}>
                                                    {/* No attachments uploaded. */}
                                                </Typography.Text>
                                            ) : (
                                                <Space direction="vertical" style={{ width: "100%" }}>
                                                    {attachments.map((a) => {
                                                        const isImage = /\.(png|jpe?g|webp|gif)$/i.test(a.file_path || "");
                                                        return (
                                                            <div
                                                                key={a.id}
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    border: "1px solid #f0f0f0",
                                                                    borderRadius: 6,
                                                                    padding: "8px 10px",
                                                                }}
                                                            >
                                                                <Space>
                                                                    {isImage ? <FileImageOutlined /> : <FilePdfOutlined />}

                                                                    <a href={`${ENDPOINT.base}/${a.file_path}`}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        style={{ fontSize: 13 }}
                                                                    >
                                                                        {a.original_name || a.file_path}
                                                                    </a>
                                                                </Space>
                                                                <Button
                                                                    type="text"
                                                                    danger
                                                                    size="small"
                                                                    icon={<DeleteIcon />}
                                                                    onClick={() => handleDeleteAttachment(a.id)}
                                                                />
                                                            </div>
                                                        );
                                                    })}
                                                </Space>
                                            )}
                                        </div>
                                    ),
                                },
                                {
                                    key: "notes",
                                    label: "Notes",
                                    children: (
                                        <div style={{ padding: "0 0 16px" }}>
                                            {tabSavedNote && !tabEditingNote ? (
                                                <div style={{
                                                    background: "#fafafa",
                                                    border: "1px solid #f0f0f0",
                                                    borderRadius: 8,
                                                    padding: "10px 14px",
                                                    marginBottom: 12,
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "flex-start",
                                                    gap: 8,
                                                }}>
                                                    <Typography.Text style={{ fontSize: 13, flex: 1, whiteSpace: "pre-wrap" }}>
                                                        {tabSavedNote}
                                                    </Typography.Text>
                                                    <Button
                                                        size="small"
                                                        type="link"
                                                        style={{ padding: 0, color: primaryColor, flexShrink: 0 }}
                                                        onClick={() => { setTabInternalNote(tabSavedNote); setTabEditingNote(true); }}
                                                    >
                                                        Edit
                                                    </Button>
                                                </div>
                                            ) : (
                                                <>
                                                    <Input.TextArea
                                                        rows={4}
                                                        placeholder="Add internal notes..."
                                                        style={{ fontSize: 13 }}
                                                        value={tabInternalNote}
                                                        onChange={(e) => setTabInternalNote(e.target.value)}
                                                    />
                                                    <Space style={{ marginTop: 8 }}>
                                                        <Button
                                                            size="small"
                                                            type="primary"
                                                            style={{ backgroundColor: primaryColor, borderColor: primaryColor }}
                                                            onClick={() => {
                                                                if (!tabInternalNote.trim()) return;
                                                                setTabSavedNote(tabInternalNote);
                                                                setTabInternalNote("");
                                                                setTabEditingNote(false);
                                                            }}
                                                        >
                                                            Save Note
                                                        </Button>
                                                        {tabEditingNote && (
                                                            <Button size="small" onClick={() => { setTabInternalNote(""); setTabEditingNote(false); }}>
                                                                Cancel
                                                            </Button>
                                                        )}
                                                    </Space>
                                                </>
                                            )}
                                        </div>
                                    ),
                                },

                                {
                                    key: "activity_timeline_tab",
                                    label: "Activity Timeline",
                                    children: (
                                        <div style={{ padding: "0 0 16px" }}>
                                            <Timeline
                                                items={filteredActivityLog.slice(0, TIMELINE_LIMIT).map((log) => ({
                                                    color: log.action_type === "sent" ? "purple"
                                                        : log.action_type === "payment_added" ? "green"
                                                            : log.action_type === "payment_updated" ? "gold"
                                                                : log.action_type === "payment_deleted" ? "red"
                                                                    : "blue",
                                                    children: (
                                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                            <Typography.Text style={{ fontSize: 12 }}>
                                                                {log.description}
                                                                {log.performed_by_name ? (
                                                                    <Typography.Text type="secondary" style={{ fontSize: 11 }}>
                                                                        {` — by ${log.performed_by_name}`}
                                                                    </Typography.Text>
                                                                ) : null}
                                                            </Typography.Text>
                                                            <Typography.Text type="secondary" style={{ fontSize: 11 }}>
                                                                {dayjs.utc(log.created_on).local().format("DD MMM YYYY hh:mm A")}
                                                            </Typography.Text>
                                                        </div>
                                                    ),
                                                }))}
                                            />
                                            {filteredActivityLog.length > TIMELINE_LIMIT && (
                                                <Button size="small" style={{ marginTop: 8 }} onClick={() => setShowAllTabTimeline(true)}>
                                                    {`View All (${filteredActivityLog.length})`}
                                                </Button>
                                            )}
                                            <Modal
                                                title="All Activity"
                                                open={showAllTabTimeline}
                                                onCancel={() => setShowAllTabTimeline(false)}
                                                footer={null}
                                                width={600}
                                            >
                                                <Timeline
                                                    items={filteredActivityLog.map((log) => ({
                                                        color: log.action_type === "sent" ? "purple"
                                                            : log.action_type === "payment_added" ? "green"
                                                                : log.action_type === "payment_updated" ? "gold"
                                                                    : log.action_type === "payment_deleted" ? "red"
                                                                        : "blue",
                                                        children: (
                                                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                                <Typography.Text style={{ fontSize: 12 }}>
                                                                    {log.description}
                                                                    {log.performed_by_name ? (
                                                                        <Typography.Text type="secondary" style={{ fontSize: 11 }}>
                                                                            {` — by ${log.performed_by_name}`}
                                                                        </Typography.Text>
                                                                    ) : null}
                                                                </Typography.Text>
                                                                <Typography.Text type="secondary" style={{ fontSize: 11 }}>
                                                                    {dayjs.utc(log.created_on).local().format("DD MMM YYYY hh:mm A")}
                                                                </Typography.Text>
                                                            </div>
                                                        ),
                                                    }))}
                                                />
                                            </Modal>
                                        </div>
                                    ),
                                },
                            ]}
                        />
                    </Card>
                </Col>
                {/* MIDDLE: Activity Timeline */}
                <Col xs={24} lg={7}>
                    <Card
                        title={
                            <Typography.Text strong style={{ color: primaryColor, fontSize: 13 }}>
                                Activity Timeline
                            </Typography.Text>
                        }
                        size="small"
                        style={{ borderRadius: 12 }}
                        bodyStyle={{ padding: "10px 12px" }}
                    >
                        {(() => {
                            const sorted = filteredActivityLog;
                            const visible = sorted.slice(0, TIMELINE_LIMIT);
                            const renderLogItem = (log) => ({
                                color: log.action_type === "sent" ? "purple"
                                    : log.action_type === "payment_added" ? "green"
                                        : log.action_type === "payment_updated" ? "gold"
                                            : log.action_type === "payment_deleted" ? "red"
                                                : "blue",
                                children: (
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <Typography.Text style={{ fontSize: 12 }}>
                                            {log.description}
                                            {log.performed_by_name ? (
                                                <Typography.Text type="secondary" style={{ fontSize: 11 }}>
                                                    {` — by ${log.performed_by_name}`}
                                                </Typography.Text>
                                            ) : null}
                                        </Typography.Text>
                                        <Typography.Text type="secondary" style={{ fontSize: 11 }}>
                                            {dayjs.utc(log.created_on).local().format("DD MMM YYYY hh:mm A")}
                                        </Typography.Text>
                                    </div>
                                ),
                            });
                            const timelineItems = visible.map(renderLogItem);
                            return (
                                <>
                                    {sorted.length === 0 ? (
                                        <div style={{ textAlign: "center", padding: "24px 0", color: "#9ca3af", fontSize: 13 }}>
                                            No activity yet
                                        </div>
                                    ) : (
                                        <>
                                            <Timeline items={timelineItems} />
                                            {sorted.length > TIMELINE_LIMIT && (
                                                <Button size="small" style={{ marginTop: 4 }} onClick={() => setShowAllTimeline(true)}>
                                                    {`View All (${sorted.length})`}
                                                </Button>
                                            )}
                                        </>
                                    )}
                                    <Modal
                                        title="All Activity"
                                        open={showAllTimeline}
                                        onCancel={() => setShowAllTimeline(false)}
                                        footer={null}
                                        width={600}
                                    >
                                        <Timeline items={sorted.map(renderLogItem)} />
                                    </Modal>
                                </>
                            );
                        })()}
                    </Card>
                </Col>

                {/* RIGHT: Important Information */}
                <Col xs={24} lg={7}>
                    <Card
                        title={
                            <Typography.Text strong style={{ color: primaryColor, fontSize: 13 }}>
                                Important Information
                            </Typography.Text>
                        }
                        size="small"
                        style={{ borderRadius: 12, height: "100%" }}
                        bodyStyle={{ padding: "10px 12px" }}
                    >
                        <Row gutter={12}>
                            <Col span={12}>
                                <Typography.Text strong style={{ fontSize: 13, display: "block", marginBottom: 6 }}>
                                    Terms & Conditions
                                </Typography.Text>
                                <Select
                                    placeholder="Select Terms & Condition"
                                    options={selectedTCOption}
                                    size="small"
                                    value={selectedValue?.value}
                                    style={{ width: "100%", marginBottom: 4 }}
                                    onChange={(value, option) => setSelectedValue(option)}
                                />
                                {selectedValue && (
                                    <Typography.Text
                                        type="secondary"
                                        style={{ fontSize: 11, cursor: "pointer", color: primaryColor, display: "block", marginBottom: 4 }}
                                        onClick={handlePreview}
                                    >
                                        Click to view Terms & Conditions
                                    </Typography.Text>
                                )}
                            </Col>

                            <Col span={12}>
                                <Typography.Text strong style={{ fontSize: 13, display: "block", marginBottom: 6 }}>
                                    Bank Details
                                </Typography.Text>
                                <Select
                                    placeholder="Select Bank Account"
                                    options={bankAcOption}
                                    size="small"
                                    value={bankAc?.value}
                                    style={{ width: "100%", marginBottom: 4 }}
                                    onChange={(value, option) => {
                                        setBankAc(option);
                                        footerForm.setFieldsValue({ bank_ac: value });
                                    }}
                                />
                                {bankAc && (
                                    <Typography.Text
                                        type="secondary"
                                        style={{ fontSize: 11, cursor: "pointer", color: primaryColor, display: "block" }}
                                        onClick={() => setBankModalOpen(true)}
                                    >
                                        Click to view Bank Details
                                    </Typography.Text>
                                )}
                            </Col>
                        </Row>

                        <Modal
                            title="Preview of selected T&C"
                            open={isModalOpen}
                            footer={null}
                            onCancel={() => setIsModalOpen(false)}
                        >
                            {selectedValue?.data ? (
                                <div
                                    style={{
                                        padding: "10px",
                                        border: "1px solid #f0f0f0",
                                        borderRadius: "8px",
                                        background: "#fafafa",
                                        minHeight: "100px",
                                    }}
                                    dangerouslySetInnerHTML={{ __html: selectedValue.data }}
                                />
                            ) : (
                                <p>No content available</p>
                            )}
                        </Modal>
                        <Modal
                            title="Bank Account Details"
                            open={bankModalOpen}
                            footer={null}
                            onCancel={() => setBankModalOpen(false)}
                        >
                            {bankAc ? (
                                <div
                                    style={{
                                        padding: "10px",
                                        border: "1px solid #f0f0f0",
                                        borderRadius: "8px",
                                        background: "#fafafa",
                                        fontSize: 13,
                                        lineHeight: 1.8,
                                    }}
                                >
                                    <div><b>Bank:</b> {bankAc.bank_name}</div>
                                    <div><b>A/c No:</b> {bankAc.ac_no}</div>
                                    <div><b>IFSC:</b> {bankAc.ifsc_code}</div>
                                    {bankAc.branch && <div><b>Branch:</b> {bankAc.branch}</div>}
                                </div>
                            ) : (
                                <p>No bank selected</p>
                            )}
                        </Modal>

                        <Divider style={{ margin: "10px 0" }} />

                        <Typography.Text strong style={{ fontSize: 12.5, display: "block", marginBottom: 4 }}>
                            Signature
                        </Typography.Text>
                        <Select
                            placeholder="Select Signature"
                            options={dgSignOption}
                            size="small"
                            value={dgSign?.value}
                            style={{ width: "100%", marginBottom: 4 }}
                            optionRender={(option) => option.data.label}
                            fieldNames={{ label: "title", value: "value" }}
                            onChange={(value, option) => setDGsign(option)}
                        />
                        {dgSign && (
                            <Typography.Text
                                type="secondary"
                                style={{ fontSize: 11, cursor: "pointer", color: primaryColor, display: "block" }}
                                onClick={() => setSignModalOpen(true)}
                            >
                                Click to view Signature
                            </Typography.Text>
                        )}
                        <Modal
                            title="Signature Preview"
                            open={signModalOpen}
                            footer={null}
                            onCancel={() => setSignModalOpen(false)}
                        >
                            {dgSign ? (
                                <div style={{ textAlign: "center", padding: 10 }}>
                                    <img
                                        src={`${ENDPOINT.base}/${dgSign.image_path}`}
                                        alt="Signature"
                                        style={{ maxWidth: "100%", maxHeight: 200, objectFit: "contain" }}
                                    />
                                </div>
                            ) : (
                                <p>No signature selected</p>
                            )}
                        </Modal>

                        <Divider style={{ margin: "10px 0" }} />



                        <Typography.Text strong style={{ fontSize: 13, display: "block", marginBottom: 6 }}>
                            Notes
                        </Typography.Text>
                        {savedNote && !editingNote ? (
                            <div style={{
                                background: "#fafafa",
                                border: "1px solid #f0f0f0",
                                borderRadius: 6,
                                padding: "8px 10px",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                                gap: 6,
                            }}>
                                <Typography.Text style={{ fontSize: 12, flex: 1, whiteSpace: "pre-wrap" }}>{savedNote}</Typography.Text>
                                <Button type="link" size="small" style={{ padding: 0, color: primaryColor, flexShrink: 0 }}
                                    onClick={() => { setInternalNote(savedNote); setEditingNote(true); }}>
                                    Edit
                                </Button>
                            </div>
                        ) : (
                            <>
                                <Input.TextArea
                                    rows={3}
                                    placeholder="Thank you for your business."
                                    style={{ fontSize: 12 }}
                                    value={internalNote}
                                    onChange={(e) => setInternalNote(e.target.value)}
                                />
                                <Space style={{ marginTop: 6 }}>
                                    <Button size="small" type="primary"
                                        style={{ backgroundColor: primaryColor, borderColor: primaryColor }}
                                        onClick={() => {
                                            if (!internalNote.trim()) return;
                                            setSavedNote(internalNote);
                                            setInternalNote("");
                                            setEditingNote(false);
                                        }}>
                                        Save
                                    </Button>
                                    {editingNote && (
                                        <Button size="small" onClick={() => { setInternalNote(""); setEditingNote(false); }}>Cancel</Button>
                                    )}
                                </Space>
                            </>
                        )}
                    </Card>
                </Col>
            </Row>

            {/* Bottom action bar — matching image */}
            <Card
                style={{ marginTop: 16, borderRadius: 12 }}
                bodyStyle={{ padding: "10px 16px" }}
            >
                <Row align="middle" justify="space-between" wrap>
                    <Col>
                        <Button icon={<ArrowLeftOutlined />} onClick={() => window.history.back()}>
                            Back
                        </Button>
                    </Col>
                    <Col>
                        <Space wrap>
                            <Button
                                disabled={!Eqslected}
                                size="medium"
                                onClick={handleAddPayment}
                            >
                                Add Payment Amount
                            </Button>
                            {!isInvoiceCreated ? (
                                <Button
                                    disabled={!Eqslected || generatingInvoice}
                                    loading={generatingInvoice}
                                    size="medium"
                                    type="primary"
                                    style={{ backgroundColor: primaryColor, borderColor: primaryColor }}
                                    onClick={handleGenerateInvoice}
                                >
                                    Save as Draft
                                </Button>
                            ) : (
                                <Button
                                    disabled={!Eqslected}
                                    size="medium"
                                    type="primary"
                                    style={{ backgroundColor: primaryColor, borderColor: primaryColor }}
                                    onClick={handleSave}
                                >
                                    Update Invoice
                                </Button>
                            )}
                            <Button
                                size="medium"
                                type="primary"
                                style={{ background: "#16a34a", borderColor: "#16a34a" }}
                                onClick={handleAddPayment}
                            >
                                Record Payment
                            </Button>
                            <Button
                                size="medium"
                                disabled={viewMode ? false : !printInvoice}
                                type="primary"
                                style={{ background: "#7c3aed", borderColor: "#7c3aed" }}
                                onClick={async () => {
                                    if (!invoiceId) return message.warning("Generate invoice first before sending.");
                                    if (onSendInvoice) {
                                        await onSendInvoice();
                                        fetchActivityLog();
                                        return;
                                    }
                                    try {
                                        await InvoiceService.updateInvoice({ status: "Sent", sent_on: dayjs().toISOString() }, invoiceId);
                                        if (onInvoiceGenerated) {
                                            onInvoiceGenerated((prev) => ({ ...prev, status: "Sent", sent_on: dayjs().toISOString() }));
                                        }
                                        message.success("Invoice marked as Sent.");
                                        fetchActivityLog();
                                    } catch (e) {
                                        console.error(e);
                                        message.error("Failed to update invoice status.");
                                    }
                                }}
                            >
                                Send Invoice
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Card>

            <Modal
                title="Choose Invoice Template"
                open={templateModalOpen}
                onCancel={() => setTemplateModalOpen(false)}
                footer={null}
            >
                <Space direction="vertical" style={{ width: "100%" }}>
                    <Button
                        block
                        size="large"
                        type="primary"
                        onClick={() => {
                            setTemplateModalOpen(false);
                            handlePrintInvoice(selectedPrintQuNo, "v1");
                        }}
                    >
                        Template 1
                    </Button>

                    <Button
                        block
                        size="large"
                        type="primary"
                        style={{ background: "#1677ff", borderColor: "#1677ff" }}
                        onClick={() => {
                            setTemplateModalOpen(false);
                            handlePrintInvoice(selectedPrintQuNo, "v2");
                        }}
                    >
                        Template 2
                    </Button>
                </Space>
            </Modal>
        </>
    );
};

// Sub Total / Discount / Taxable Amount / CGST / SGST rows in the summary box
const SummaryRow = ({ label, value, editable, onChange }) => (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
        <Typography.Text style={{ fontSize: 13, color: "#595959" }}>{label}</Typography.Text>
        {editable ? (
            <InputNumber
                size="small"
                min={0}
                value={value}
                onChange={onChange}
                style={{ width: 110 }}
                formatter={(v) => `₹ ${v}`}
                parser={(v) => v.replace(/[₹\s]/g, "")}
            />
        ) : (
            <Typography.Text style={{ fontSize: 13, fontWeight: 600 }}>
                ₹ {Number(value || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
            </Typography.Text>
        )}
    </div>
);

export default AddInvoiceData;